import { GET_UNIT_LI, GET_UNIT_LI_COUNT, GET_UNIT_LI_PAGE, GET_UNIT_LI_PAGE_DATA, GET_UNIT, GET_UNIT_SLUG_CONDITION, GET_UNIT_DATA, API_ERROR, SAVE_UNIT, SAVE_UNIT_DATA, NEW_UNIT_INIT, DELETE_UNIT, UNIT_SCAN_IND_SET, GET_GROUP, GET_GROUP_DATA, DELETE_GROUP, SAVE_GROUP, SAVE_GROUP_DATA, NEW_GROUP_INIT, GET_GROUP_UTYPE_UNIT_LI, GET_GROUP_UTYPE_UNIT_LI_DATA, GET_GROUP_LI, GET_GROUP_LI_DATA, GET_SER, GET_SER_DATA, NEW_SER_INIT, DELETE_SER, SAVE_SER, SAVE_SER_DATA, GET_SER_LI, GET_SER_LI_DATA, GET_USER, GET_USER_DATA, NEW_USER_INIT, DELETE_USER, SAVE_USER, SAVE_USER_DATA, GET_USER_LI, GET_USER_LI_DATA, AUTH_CH, AUTH_CH_DATA, AUTH_SET, AUTH_LOUT } from '../constants';
import { makeSingleArgActionCreator as singleArgAct } from './common';

export const getUnitLi = singleArgAct(GET_UNIT_LI);
export const getUnitLiCount = singleArgAct(GET_UNIT_LI_COUNT);
export const getUnitLiPage = singleArgAct(GET_UNIT_LI_PAGE);
export const getUnitLiPageData = singleArgAct(GET_UNIT_LI_PAGE_DATA);

export const deleteUnit = singleArgAct(DELETE_UNIT);
export const getUnit = singleArgAct(GET_UNIT);
export const getUnitSlugCondition = singleArgAct(GET_UNIT_SLUG_CONDITION);
export const getUnitData = singleArgAct(GET_UNIT_DATA);
export const newUnitInit = singleArgAct(NEW_UNIT_INIT);
export const saveUnit = singleArgAct(SAVE_UNIT);
export const saveUnitData = singleArgAct(SAVE_UNIT_DATA);
export const unitScanIndSet = singleArgAct(UNIT_SCAN_IND_SET);

export const apiError = singleArgAct(API_ERROR);

export const getGroup = singleArgAct(GET_GROUP);
export const getGroupData = singleArgAct(GET_GROUP_DATA);
export const newGroupInit = singleArgAct(NEW_GROUP_INIT);
export const deleteGroup = singleArgAct(DELETE_GROUP);
export const saveGroup = singleArgAct(SAVE_GROUP);
export const saveGroupData = singleArgAct(SAVE_GROUP_DATA);
export const getGroupUtypeUnitLi = singleArgAct(GET_GROUP_UTYPE_UNIT_LI);
export const getGroupUtypeUnitLiData = singleArgAct(GET_GROUP_UTYPE_UNIT_LI_DATA);

export const getGroupLi = singleArgAct(GET_GROUP_LI);
export const getGroupLiData = singleArgAct(GET_GROUP_LI_DATA);

export const getSer = singleArgAct(GET_SER);
export const getSerData = singleArgAct(GET_SER_DATA);
export const newSerInit = singleArgAct(NEW_SER_INIT);
export const deleteSer = singleArgAct(DELETE_SER);
export const saveSer = singleArgAct(SAVE_SER);
export const saveSerData = singleArgAct(SAVE_SER_DATA);

export const getSerLi = singleArgAct(GET_SER_LI);
export const getSerLiData = singleArgAct(GET_SER_LI_DATA);

export const getUser = singleArgAct(GET_USER);
export const getUserData = singleArgAct(GET_USER_DATA);
export const newUserInit = singleArgAct(NEW_USER_INIT);
export const deleteUser = singleArgAct(DELETE_USER);
export const saveUser = singleArgAct(SAVE_USER);
export const saveUserData = singleArgAct(SAVE_USER_DATA);

export const getUserLi = singleArgAct(GET_USER_LI);
export const getUserLiData = singleArgAct(GET_USER_LI_DATA);

export const authCh = singleArgAct(AUTH_CH);
export const authChData = singleArgAct(AUTH_CH_DATA);
export const authSet = singleArgAct(AUTH_SET);
export const authLout = singleArgAct(AUTH_LOUT);

